<template lang="html">
  <vs-card class="cardx">
    <div slot="header" style="padding:10px">
      <h3>
        Tools
      </h3>
    </div>
  <div>  
    <vs-row>

          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <label class="vs-input--label">Partner</label>
            <v-select
              @input="onPartnerChange"
              v-model="form.partner_id"
              name="partner"  
              :options="partners"
              :reduce="el => el.id" label="name"  /> 
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px;font-size: 1rem;margin-top: 2rem;">
              Partner ID: {{form.partner_id}}
          </vs-col>
    </vs-row> 
    <vs-row>

          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <label class="vs-input--label">Zones</label>
            <v-select
            :disabled="!form.partner_id"
              @input="onZonesChange"
              v-model="form.zone_id"
              name="partner"  
              :options="zones"
              :reduce="el => el.id" label="name"  /> 
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px;font-size: 1rem;margin-top: 2rem;">
              Zone ID: {{form.zone_id}}
          </vs-col>
    </vs-row> 

    <vs-row>

        <vs-col   vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Route</label>
          <v-select
            :disabled="!form.zone_id"
            @input="onRoutesChange"
            v-model="form.route_id"
            :options="routes"
            :reduce="el => el.id" label="name"  />
        </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px;font-size: 1rem;margin-top: 2rem;">
              Route ID: {{form.route_id}}
          </vs-col>
        </vs-row>
        <vs-row  v-if="form.route_id"> 
            <vs-col   vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
                <label class="vs-input--label">Stations</label>
             

      <vs-table
        stripe 
        :data="this.stations"> 
        <template slot="thead"> 
          <vs-th  >
            Name
          </vs-th>
          <vs-th >
            Station id
          </vs-th> 
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="station.id" v-for="station in data"> 
            <vs-td>
              {{station.station.name}}
            </vs-td>
            <vs-td>
              {{station.station.id}}
            </vs-td> 
          </vs-tr>
        </template>
      </vs-table>

 
            </vs-col>
        </vs-row>
    <vs-row>

        <vs-col   vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Drivers</label>
          <v-select 
            :disabled="!form.partner_id"
            v-model="form.driver_id"
            :options="drivers"
            :reduce="el => el.id" :get-option-label="(option)=>{ return `${option.firstname} ${option.lastname}`}" label="firstname"  />
        </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px;font-size: 1rem;margin-top: 2rem;">
              Driver ID: {{form.driver_id}}
          </vs-col>
        </vs-row>
    <vs-row>

        <vs-col   vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Vehicles</label>
          <v-select 
            :disabled="!form.partner_id"
            v-model="form.vehicle_id"
            :options="vehicles"
            :reduce="el => el.id"  label="plate"  />
        </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px;font-size: 1rem;margin-top: 2rem;">
              Vehicle ID: {{form.vehicle_id}}
          </vs-col>
        </vs-row>
  </div>
  </vs-card>
</template>


<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'; 

export default {
  components:{
    Datepicker
  },
	data (){
		return {
            form : {

            },
            partner_namespace: null,
            partners: [],
            routes: [],
            drivers: [],
            trips: [],
            zones: [],
            stations: []
		}
	},
	computed : {
    ...mapGetters('users',['userCan']),  
	}, 

    mounted(){ 
      this.initialData();
    }, 
	methods: {
		...mapActions('coupons',['fetchCoupons','storeCoupon','deleteCoupon']), 
        ...mapActions('partners',['fetchPartners']), 
        ...mapActions('zones',['getZones', 'fetchPartnerZones']),
        ...mapActions('routes',['fetchRoutes']),
        ...mapActions('drivers',['getDrivers']),
      ...mapActions('vehicles',['fetchVehicles']),

        initialData(){ 
            this.fetchPartners({limit: 500}).then(data=>{
                this.partners = _.cloneDeep(data.data.partners); 
            });  

            let payload = {
            page: this.page,
            limit: 400
            };
             
          this.getZones(payload)
            .then(data=>{
                console.log('get zones', data.zones)
              this.zones = data.zones;
            })
            .catch(error=>{

            }) 
        }, 
        onPartnerChange(){
            console.log('PartnerChange to:', this.form.partner_id)
            let payload = {
                page: 1,
                limit: 1000000
                }; 
            payload.partner_id= this.form.partner_id; 
            this.getDrivers(payload)
            .then(data=>{
                this.drivers = data.drivers;
            })
            .catch(error=>{

            })


        this.fetchVehicles({page:1, limit: 1000, partner_id: this.form.partner_id})
          .then(data=>{
            this.vehicles = data.vehicles; 
          })
          .catch(error =>{

          });

        },

        onZonesChange(){  
            delete this.form.route_id;
            this.fetchRoutes({limit: 500, zone_id: this.form.zone_id})
            .then(data=>{
                this.routes = data.routes;
            })
            .catch(error=>{

            })
        },
        onRoutesChange(){
            this.routes.map((child) => {
                if(child.id===this.form.route_id){
                    this.stations=child.stations; 
                }
            }
            );
        },
	}

}
</script>
